import { createContext } from 'react';

export type ScreenshotContextType = {
  ref: React.MutableRefObject<null> | null;
  image: string;
  takeScreenshotOfElement: () => void;
};

const ScreenshotContext = createContext<ScreenshotContextType>({
  ref: null,
  image: '',
  takeScreenshotOfElement: () => {},
});

export default ScreenshotContext;
